import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * "This is a private charger", in the driver's language, where a Start
 * button would be (Warren, 2026-10-22: the private switch on the pre-start
 * screen). Shown on the pre-start screen (namespace preSession) when the Api
 * says this driver may not start here, and on the station page (namespace
 * station) when every stall the driver could see is private. It offers no
 * action: only the site can add a driver to a private charger.
 *
 * No stylesheet of its own: each page passes its card classes, so the notice
 * reads as that page's own card (and renders in tests without a CSS loader).
 */
export interface PrivateChargerNoticeProps {
  ns: 'preSession' | 'station';
  className?: string;
  titleClassName?: string;
  hintClassName?: string;
}

export function PrivateChargerNotice({ ns, className, titleClassName, hintClassName }: PrivateChargerNoticeProps) {
  const { t } = useTranslation(ns);
  return (
    <div className={className} role="status" data-private-charger-notice="">
      <Lock size={22} aria-hidden="true" />
      <p className={titleClassName}>{t('privateCharger.title')}</p>
      <p className={hintClassName}>{t('privateCharger.hint')}</p>
    </div>
  );
}
